import axios from 'axios';
import { setApi } from '@/api/api';
import { useGlobalsStore, useUserStore } from '@/stores';
import Cookies from 'js-cookie';
import { studentAppHeaders } from '@/utils/student-app-headers';
import { logSafeError } from '@/utils/log-safe-error';

export default defineNuxtPlugin((nuxtApp) => {
  const api = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
  });
  const accessToken = useCookie('accessToken');

  let serverHeaders = {};
  if (process.server) {
    const req = useRequestEvent()?.node.req;
    serverHeaders = studentAppHeaders(
      useRuntimeConfig().ssrProxySecret,
      req?.headers['x-forwarded-for'],
      req?.socket.remoteAddress,
    );
  }

  api.interceptors.request.use((config) => {

    let accessTokenValue;
    if(process.client) {
      accessTokenValue = Cookies.get('accessToken');
    } else {
      accessTokenValue = accessToken.value;
    }

    if (accessTokenValue) {
      config.headers['Authorization'] = `Token ${accessTokenValue}`;
    }
    for (const [name, value] of Object.entries(serverHeaders)) {
      config.headers[name] = value;
    }
    return config;
  });

  api.interceptors.response.use(
    (response) => {
      const xVersion = response.headers['x-version'];
      if (xVersion) {
        useGlobalsStore().setReleaseVersion(Number(xVersion));
      }
      return response;
    },
    (error) => {
      if (process.server) {
        logSafeError(error);
      }
      return Promise.reject(error);
    }
  );
  
  setApi(api);
  nuxtApp.provide('api', api);
});